window.portalModule.controller 'RetiredPracticeController',
['$scope', '$stateParams',
($scope, $stateParams) ->
    $scope.practiceName = $stateParams.practiceName
    $scope.showRetiredMessage = true
]
